<template>
  <b-form-input
    v-model="selectModel"
  />
</template>

<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput,
} from 'bootstrap-vue'

export default {
  components: {
    BFormInput,
  },
  props: {
    selectModel: {
      type: [String, Number],
      required: true,
      default: '',
    },
  },
  data() {
    return {
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
  },
}
</script>

        <style lang="scss">
        </style>
